import { render, staticRenderFns } from "./homeMessage.vue?vue&type=template&id=51429512&scoped=true"
import script from "./homeMessage.vue?vue&type=script&lang=js"
export * from "./homeMessage.vue?vue&type=script&lang=js"
import style0 from "./homeMessage.vue?vue&type=style&index=0&id=51429512&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51429512",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51429512')) {
      api.createRecord('51429512', component.options)
    } else {
      api.reload('51429512', component.options)
    }
    module.hot.accept("./homeMessage.vue?vue&type=template&id=51429512&scoped=true", function () {
      api.rerender('51429512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/homeMessage.vue"
export default component.exports